module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ax-dd048088f167a2fc17f43ceae4e6d25f.svg";